export function pluralizeFacility(count: number, includeCount = true): string {
  return `${includeCount ? `${count} ` : ""}${count === 1 ? "facility" : "facilities"}`;
}

export function pluralizeFacilityWithThe(count: number): string {
  return count === 1 ? "this facility" : "these facilities";
}
